/**
 * Internal dependencies
 */
import metadata from "./block.json";

import $ from "jquery";

import "./../../vendor/flipdowncounter/flipdowncounter.js";

import "./../../vendor/flipdowncounter/flipdowncounter.css";

import "./../style.scss";
import icons from "./../icons.js";

import {
  timeToString,
  newID,
  PlayerClicked,
  rateMarks,
  masterVolumeMarks,
  fingerMaxAngle,
  translateDialedNumber,
  Key,
} from "../script";

import { AudioDescription, speedIcon } from "../elmercat";

/**
 * WordPress dependencies
 */

import { __, _x } from "@wordpress/i18n";
import {
  useRef,
  useEffect,
  useLayoutEffect,
  useState,
} from "@wordpress/element";

import {
  AnglePickerControl,
  Button,
  Popover,
  Dropdown,
  Disabled,
  PanelBody,
  RangeControl,
  FormToggle,
  Flyout,
  CheckboxControl,
  SelectControl,
  Spinner,
  ToggleControl,
  Toolbar,
  ToolbarDropdownMenu,
  ToolbarGroup,
  ToolbarItem,
  ToolbarButton,
} from "@wordpress/components";

export default function Time({ attributes, mode, isSelected }) {
  const componentProps = {};
  for (const setting in metadata.attributes) {
    const prop = metadata.attributes[setting]["attribute"];
    componentProps[prop] = attributes[setting];
  }

  if (mode === "save") {
    return (
      <div
        id={attributes.id}
        class={attributes.class}
        {...componentProps}
      >
        * ElmerCat Time Announcer
      </div>
    );
  }

  const audioContext = useRef();
  const audioElement = useRef();
  const audioSource = useRef();

  const [contextRunning, setContextRunning] = useState(false);

  const [valueA, setValueA] = useState(0);
  const [valueB, setValueB] = useState(0);
  const [valueC, setValueC] = useState(0);
  const [valueD, setValueD] = useState(0);
  const lampA = useRef();
  const lampB = useRef();
  const lampC = useRef();
  const lampD = useRef();
  const keyA = useRef();
  const keyB = useRef();
  const keyC = useRef();
  const keyD = useRef();

  useEffect(() => {
    //
    audioContext.current = new AudioContext();

    audioContext.current.onstatechange = (e) => {
      setContextRunning(audioContext.current.state === "running");
      console.log("audioContext.current.state:  " + audioContext.current.state);
    };

    $(".clock .time").flipcountdown({
      size: "lg",
      am: true,
      speedFlip: 100,
      tick: tickNow,
    });

    console.log("Time Announcer component mounted");
  }, []);

  return (
    <div
      id={attributes.id}
      class={attributes.class}
      {...componentProps}
    >
      <div class='left-panel'>
        <div class='keystrip-a linekeys'>
          <Key
            lampClass={contextRunning ? "lamp-on lamp" : "lamp"}
            label='context'
            labelFirst={true}
            valueVar='CTX'
            onClick={contextKey}
          ></Key>
          <Key
            valueVar='RLS'
            label='release'
            labelFirst={true}
            onClick={releaseKey}
          ></Key>
          <Key
            valueVar='TLK'
            label='talk'
            labelFirst={true}
            onClick={talkKey}
          ></Key>
          <Key
            valueVar='SDR'
            label='sender'
            labelFirst={true}
            onClick={senderKey}
          ></Key>
          <Key
            valueVar='END'
            label='end'
            labelFirst={true}
            onClick={endKey}
          ></Key>
        </div>
      </div>
      <div class='right-panel'>
        <div class='clock'>
          <span class='time'></span>
        </div>
      </div>
    </div>
  );

  var tickNow = function () {
    return new Date();
  };

  function contextKey(e) {
    if (audioContext.current.state === "running") {
      audioContext.current.suspend();
    } else {
      audioContext.current.resume();
    }
    console.log("contextKey" + e);
  }

  function endKey(e) {
    console.log("endKey - audioElement: -- ");
    audioElement.current.pause();

    console.dir(audioElement.current);
  }

  function senderKey(e) {
    console.log("senderKey - audioElement: -- ");
    audioElement.current.play();

    console.dir(audioElement.current);
  }

  function talkKey(e) {
    console.log("talkKey" + e);

    audioElement.current = new Audio(
      "./../wp-content/plugins/elmercat/assets/audio/PraxLDO.mp3"
    );
    console.log("talkKey - audioElement: --");
    console.dir(audioElement.current);

    audioSource.current = audioContext.current.createMediaElementSource(
      audioElement.current
    );

    audioSource.current.connect(audioContext.current.destination);

    console.log("talkKey - audioSource: -- ");
    console.dir(audioSource.current);
  }

  function releaseKey(e) {
    console.log("releaseKey audioContext: -- ");
    console.dir(audioContext.current);
  }
  function keypressB(e) {
    console.log("keypressB" + e);
  }
  function keypressC(e) {
    console.log("keypressC" + e);
  }
  function keypressD(e) {
    console.log("keypressD" + e);
  }
}
